<nb-accordion class="mb-3 shadow-none">
  <nb-accordion-item [collapsed]="false">
    <nb-accordion-item-header>INFORMAZIONI</nb-accordion-item-header>
    <nb-accordion-item-body>
      <nb-alert
        [outline]="outline"
        
        class="hm_alert"
      >
        <div
          class="{{status}}"
          [innerHTML]="current_info?.info.it"
        ></div>

        <youtube-player
          *ngIf="youtube_code"
          class="mt-4"
          videoId="{{youtube_code}}"
        ></youtube-player>

      </nb-alert>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>
